export default function Find()
{
    return (
        <input type="text" placeholder="Szukaj..." 
        style={{padding: "10px", fontSize: "20px", border: "2px solid black", borderRadius: "5px"}} >

        
        </input>
    );
}